export default function toast(message, type = "error") {

  const colors = {
    success: "green",
    error: "red",
    warning: "orange",
    info: "blue"
  };

  if (window.M) {
    window.M.Toast.dismissAll();

    window.M.toast({
      html: message,
      classes: colors[type] || "grey"
    });
  }
}